import React, { forwardRef, useRef, useState } from 'react'

import { HandlerOf } from '../../helpers/typeHelper'
import { mergeRefs } from '../../helpers/utils'
import { TextInput, TextInputProps } from './TextInput'

interface CurrencyInputProps {
  onChange?: HandlerOf<string | number | undefined>
}

function formatNumber(n: string) {
  // format number 1000000 to 1,234,567
  return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const CurrencyInput = forwardRef(function CurrencyInput(
  props: CurrencyInputProps & TextInputProps,
  ref: any
) {
  const [value, setValue] = useState(props.value)
  const inputRef = useRef<HTMLInputElement>(null)
  const input = inputRef.current

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    setValue(e.target.value)
    props.onChange?.(e)
  }

  // https://codepen.io/akalkhair/pen/dyPaozZ
  function formatCurrency() {
    if (!input) return

    let inputVal = input.value
    const originalLen = inputVal.length
    let caretPos = input.selectionStart || 0

    // check for decimal
    if (inputVal.indexOf('.') >= 0) {
      const decimalPos = inputVal.indexOf('.')
      let leftSide = inputVal.substring(0, decimalPos)
      let rightSide = inputVal.substring(decimalPos)

      leftSide = formatNumber(leftSide)
      rightSide = formatNumber(rightSide)
      rightSide = rightSide.substring(0, 2)

      inputVal = leftSide + '.' + rightSide
    } else {
      inputVal = formatNumber(inputVal)
    }

    // send updated string to input
    setValue(inputVal)
    props.onChange?.(inputVal)

    // put caret back in the right position
    const updatedLen = inputVal.length
    caretPos = updatedLen - originalLen + caretPos
    if (caretPos !== 0) {
      setTimeout(() => input.setSelectionRange(caretPos, caretPos), 1)
    }
  }

  return (
    <TextInput
      ref={mergeRefs([ref, inputRef])}
      {...props}
      value={value}
      onChange={handleChange}
      onKeyUp={formatCurrency}
      onBlur={formatCurrency}
      inputMode="numeric"
      isCurrency
    />
  )
})
